// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__nh-78","right":"styles_right__3cMMR"};